export type GalleryPhoto = { assetId?: string | undefined };

export type GallerySelection = {
  photoId: string | null;
  index: number;
};

export function resolveGallerySelection<T extends GalleryPhoto>(
  photos: readonly T[],
  selection: GallerySelection,
): { photo: T | undefined; photoId: string | null; index: number } {
  if (photos.length === 0) return { photo: undefined, photoId: null, index: 0 };

  const identityIndex = selection.photoId
    ? photos.findIndex((photo) => photo.assetId === selection.photoId)
    : -1;
  const index =
    identityIndex >= 0 ? identityIndex : Math.min(Math.max(selection.index, 0), photos.length - 1);
  const photo = photos[index];

  return {
    photo,
    photoId: photo?.assetId ?? null,
    index,
  };
}
